<template>
    <g>
        <g>
            <g>
                <path :style="{ fill: color }" d="M31.4,79.4c2.5-0.8,4.5-1.5,5.5-1.8c0.4-0.2,0.7-0.2,0.7-0.2l3.3-1.1c0.8-0.3,1.3-1,1.3-1.9l-0.1-6
			c-2.5-2.7-4.6-5.7-5.8-8.2c-0.8-1.7-1.5-4-2-6.8c-0.3,0.2-0.6,0.5-0.9,0.5c-0.5,0-0.9,0-1.3-0.3c0,5.1-2,19.2-2,19.2l1.1-0.3
			c0,0-0.9,5.3-1.6,7.1c0,0-0.3,0.4-0.3,0.5C30.1,79.8,30.8,79.6,31.4,79.4z"/>
                <path :style="{ fill: color }" d="M65.9,74.3c0,0.9,0.5,1.6,1.3,1.9l3.3,1.1c0,0,0.3,0.1,0.7,0.2c1,0.3,3,1,5.5,1.8
			c0.8,0.2,1.6,0.5,2.4,0.8c-3-5.7-3.5-18.8-3.6-26.9c-0.3,0.2-0.7,0.3-1.1,0.3c-0.4,0-0.7-0.1-1-0.4c-0.3,2.1-0.7,3.8-1.1,5.1
			c-0.2,0.7-0.5,1.5-0.9,2.3c0,0,0,0,0,0.1c-0.1,0.2-0.2,0.4-0.3,0.6c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.3-0.3,0.5
			c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.3-0.3,0.5c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.1-0.1,0.2-0.2,0.2
			c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.3,0.4
			c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.2-0.2,0.3
			c-0.1,0.1-0.2,0.3-0.4,0.4c-0.1,0.1-0.2,0.2-0.2,0.3c-0.1,0.1-0.3,0.3-0.4,0.4c-0.1,0.1-0.2,0.2-0.2,0.3c0,0-0.1,0.1-0.1,0.1
			L65.9,74.3z"/>
            </g>
        </g>
        <path :style="{ fill: color }" d="M73.6,42.7l0.1-0.4c0.7-0.6,1.8-1.2,2.9-1.3c0-0.4,0.1-0.8,0.1-1.3c1.3-3.9,2.6-8.6,2.6-12
	c0-5.5-4.6-11.6-7.6-14.3c-0.6-0.6-1.2-1.1-1.6-1.3c0,0-0.1,0-0.1-0.1c-2.2-1.2-7-0.2-7-0.2s0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
	c-0.8-0.4-7.6-3.4-12.3-3.7c-5.1-0.3-19.1,9.1-20.9,16c-0.9,3.5-0.3,10.4,0.6,17c1.4-0.4,3,0.4,3.9,1.2l0.8,4.1l1.2,1l0.1-3.4
	c0.2-2.4,3.5-3.2,4.8-3.7c2.1-0.7,7.1-1.6,13.7-5.3c6.6-3.8,10.9-11,10.9-11s5.1,7.5,6.4,11.6C72.7,37.7,73.2,40.5,73.6,42.7z"/>
    </g>
</template>

<script>
    import Hair from './Hair';

    export default {
        name: 'Hair12',
        mixins: [Hair],
    }
</script>

